'use strict';

var React = require('react');

var SvgOutgoingMajor = function SvgOutgoingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-7c0-.829.67-1.5 1.5-1.5h4.5v2h-4v6h14v-6h-4v-2h4.5zm-7.5 6a1 1 0 0 1-1-1v-7c0-2.757 2.243-5 5-5h2.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a.998.998 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l1.293-1.293h-2.586c-1.654 0-3 1.346-3 3v7a1 1 0 0 1-1 1z"
  }));
};

exports.SvgOutgoingMajor = SvgOutgoingMajor;
